// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, SimpleGrid, Tabs, Text as MantineText } from '@mantine/core';
import { IconEye, IconLayoutGrid, IconMail } from '@tabler/icons';
import { FC } from 'react';
import { ThemeText } from '../../../Atoms/ThemeText';
import { ConstantS } from '../../../Service/ConstantS';
import { MixpanelS } from '../../../Service/MixpanelS';
import { ProfileShare } from '../../../Service/ProfileS';
import { MailOutBoundConfigDTO } from '../../../Types/MailT';
import { GrayBoxV2 } from '../../../Atoms/GrayBox';
import { moduleScopeGroups, visibilityScopeGroups } from './bookitupTeamScopes';
import { formatDateTime, formatRelativeDateTime, getTextValue } from './bookitupTeamUtils';
import TeamEmailSettings from './TeamEmailSettings';
import TeamPermissions from './TeamPermissionOptions';

const TeamInfoItem: FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box>
    <MantineText size="xs" color="dimmed" transform="uppercase">
      {label}
    </MantineText>
    <ThemeText size="sm" weight={500}>
      {value}
    </ThemeText>
  </Box>
);

const TeamMemberDetails: FC<{
  share: ProfileShare;
  mailOutboundConfigs: MailOutBoundConfigDTO[];
  loadingMailAccounts: boolean;
}> = ({ share, mailOutboundConfigs, loadingMailAccounts }) => (
  <>
    <GrayBoxV2>
      <SimpleGrid
        cols={3}
        breakpoints={[
          { maxWidth: 'md', cols: 2 },
          { maxWidth: 'sm', cols: 1 },
        ]}
      >
        <TeamInfoItem label="Vorname" value={getTextValue(share.firstName)} />
        <TeamInfoItem label="Nachname" value={getTextValue(share.lastName)} />
        <TeamInfoItem label="E-Mail" value={share.email} />
        <TeamInfoItem label="Account erstellt" value={formatDateTime(share.createdAt)} />
        <TeamInfoItem label="Letzter Login" value={formatRelativeDateTime(share.lastLogin)} />
      </SimpleGrid>
    </GrayBoxV2>
    <Tabs
      defaultValue="modules"
      mt="md"
      onTabChange={(settingTab) => {
        if (settingTab) {
          MixpanelS.track(ConstantS.TrackingEvents.TeamMemberSettingsTabOpened, {
            appUserId: share.applicationUserId,
            tab: settingTab,
          });
        }
      }}
      styles={(theme) => ({
        tab: {
          '&[data-active]': {
            fontWeight: 'bolder',
            color: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[3],
          },
        },
      })}
    >
      <Tabs.List sx={{ flexWrap: 'nowrap', overflowX: 'auto' }}>
        <Tabs.Tab value="modules" icon={<IconLayoutGrid size={14} />}>
          Module
        </Tabs.Tab>
        <Tabs.Tab value="visibility" icon={<IconEye size={14} />}>
          Sichtbarkeit
        </Tabs.Tab>
        <Tabs.Tab value="email" icon={<IconMail size={14} />}>
          E-Mail
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="modules" pt="lg">
        <TeamPermissions groups={moduleScopeGroups} share={share} />
      </Tabs.Panel>

      <Tabs.Panel value="visibility" pt="lg">
        <TeamPermissions groups={visibilityScopeGroups} share={share} />
      </Tabs.Panel>

      <Tabs.Panel value="email" pt="lg">
        <TeamEmailSettings
          share={share}
          mailOutboundConfigs={mailOutboundConfigs}
          loadingMailAccounts={loadingMailAccounts}
        />
      </Tabs.Panel>
    </Tabs>
  </>
);

export default TeamMemberDetails;
